import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const AgeVerification = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('age-verified');
    if (!verified) {
      setOpen(true);
    }
  }, []);

  const handleVerify = (isOver18) => {
    if (isOver18) {
      localStorage.setItem('age-verified', 'true');
      setOpen(false);
    } else {
      window.location.href = 'https://www.google.com';
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" hideClose>
        <DialogHeader>
          <DialogTitle className="text-2xl font-display text-[#0a1128]">
            Age Verification Required
          </DialogTitle>
          <DialogDescription className="text-base pt-4">
            You must be 18 years or older to access this website. Our products contain tobacco and are intended for adult use only.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-4">
          <Button
            onClick={() => handleVerify(true)}
            className="w-full bg-[#D4AF37] hover:bg-[#C5A028] text-[#0a1128] font-semibold h-12"
          >
            I am 18+ years old
          </Button>
          <Button
            onClick={() => handleVerify(false)}
            variant="outline"
            className="w-full h-12"
          >
            I am under 18
          </Button>
        </div>
        <p className="text-xs text-gray-500 text-center pt-2">
          By entering this site, you accept our terms and conditions.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default AgeVerification;